import type { RoundAggregate } from "@engine/round/aggregate";
import type { UserProfiles } from "@lib/types";

export function emailExistsInRound(
  email: string,
  round: RoundAggregate,
  userProfiles: UserProfiles,
): boolean {
  return Object.values(round.members).some(
    (member) =>
      member.status === "active" &&
      userProfiles[member.userId]?.email === email,
  );
}
